import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import NewFile from './staticfiles/NewFile';
import StaticFile from './StaticFiles';
import { PrivateRoute } from '../components';

const propTypes = {
  features: PropTypes.shape({}).isRequired,
  match: PropTypes.shape({
    path: PropTypes.string.isRequired,
  }).isRequired,
};

function StaticFilesRouter({ match }) {
  return (
    <Switch>
      <Route exact path={`${match.path}`} component={StaticFile} />
      <PrivateRoute exact path={`${match.path}/new`} component={NewFile} />
    </Switch>
  );
}

function mapStateToProps(state) {
  return {
    features: state.features,
  };
}
StaticFilesRouter.propTypes = propTypes;
export default connect(mapStateToProps)(StaticFilesRouter);
